import { Box, Grid } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import clsx from 'clsx';
import { Markup } from 'interweave';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';

import strapiApi from '../../api/strapi';
import Metatags from '../../components/MetaTags/metatags';
import SeminarPageHeader from '../../components/SeminarPageHeader';
import fontsStyles from '../../styles/fontStyles';
import styles from './styles';

// ✅ Fuera del componente padre
const GoogleFormContent = ({ seminar }) => {
  const classes = styles();
  const fontClasses = fontsStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.seminarFormWrapper}>
      <Box className={classes.seminarFormContentWrapper}>
        <Box className={classes.seminarContentBox}>
          <Box className={classes.formSpacing}>
            <h4 className={clsx(fontClasses.h4, classes.titleContent)}>
              {t('seminarsPage.enrollments')}
            </h4>
            <p className={clsx(fontClasses.p)}>{t('seminarsPage.enrollmentsText')}</p>
          </Box>
          <iframe
            sandbox
            title='Survey'
            src={seminar.form}
            frameBorder='0'
            marginHeight='0'
            marginWidth='0'
            className={classes.googleFormStyle}
          >
            <CircularProgress />
          </iframe>
        </Box>
      </Box>
    </Box>
  );
};

// ✅ Fuera del componente padre
const SeminarContent = ({ seminar }) => {
  const classes = styles();
  const fontClasses = fontsStyles();

  return (
    <Box className={classes.seminarPageWrapper}>
      <Box className={classes.seminarPageContentWrapper}>
        <Grid container spacing={6}>
          <Grid item md={7} sm={12}>
            {/* ✅ Strapi 5: directo, sin .attributes */}
            {seminar.course_content.map((item, index) => (
              <Box key={index} className={classes.seminarContentBox}>
                <h4 className={clsx(fontClasses.h4, classes.titleContent)}>{item[0]}</h4>
                <Markup content={item[1]} className={clsx(fontClasses.p, classes.textContent)} />
              </Box>
            ))}
            {seminar.form && seminar.form !== ' ' && <GoogleFormContent seminar={seminar} />}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

const SeminarPage = () => {
  const { id } = useParams();
  const history = useHistory();
  const { t, i18n } = useTranslation();

  const [seminar, setSeminar] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    const fetchSeminar = async () => {
      setLoading(true);

      try {
        const response = await strapiApi.get('/courses', {
          params: {
            'filters[identification][$eq]': id,
            locale: i18n.language,
            'populate[image][fields][0]': 'url',
          },
        });

        const total = response.data.meta.pagination.total;

        if (total === 0) {
          history.push('/capacitaciones');
          return;
        }

        // ✅ Strapi 5: datos planos, sin .attributes
        setSeminar(response.data.data[0]);
      } catch (err) {
        console.error('error', err);
        history.push('/capacitaciones');
      } finally {
        setLoading(false);
      }
    };

    fetchSeminar();
  }, [id, i18n.language]);

  return (
    <Box>
      <Metatags
        title='CEMCA | Capacitaciones'
        description='Descubre nuestro catálogo de capacitaciones diseñadas para impulsar tu crecimiento profesional.'
      />
      {loading && (
        <Box
          sx={{ height: '90vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <CircularProgress />
        </Box>
      )}
      {seminar && !loading && (
        <>
          <SeminarPageHeader backTo={t('navbar.courses')} seminar={seminar} />
          <SeminarContent seminar={seminar} />
        </>
      )}
    </Box>
  );
};

export default SeminarPage;
